import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import GradeIcon from "@mui/icons-material/Grade";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import TuneIcon from "@mui/icons-material/Tune";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LoadMoreSkeleton from "../../Components/LoadMoreSkeleton";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { storeIds } from "../../constants/storeIds";
const STYLES = `
  .rmc-mobile-bar {
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 8px;
  }
  .rmc-layout {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    margin-top: 14px;
  }

  .rmc-sidebar {
    width: 210px;
    flex-shrink: 0;
    position: sticky;
    top: 80px;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    padding-right: 4px;
    transition: opacity 0.2s;
  }

  .rmc-filter-section {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f3f3f3;
  }
  .rmc-filter-section:last-child { border-bottom: none; }

  .rmc-filter-heading {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #aaa;
    margin: 0 0 9px 0;
  }

  .rmc-pill-group { display: flex; flex-wrap: wrap; gap: 6px; }

  .rmc-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 20px;
    border: 1.5px solid #ddd;
    font-size: 0.78rem;
    font-weight: 500;
    color: #555;
    background: #fafafa;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    text-decoration: none;
  }
  .rmc-pill.active {
    border-color: #1a73e8;
    background: #e8f0fe;
    color: #1a73e8;
  }
  .rmc-pill img { width: 17px; object-fit: contain; }

  .rmc-cat-nav { display: flex; flex-direction: column; gap: 1px; }
  .rmc-cat-link {
    font-size: 0.83rem;
    color: #444;
    padding: 5px 8px;
    border-radius: 6px;
    transition: background 0.15s;
    cursor: pointer;
    text-decoration: none;
    display: block;
  }
  .rmc-cat-link:hover { background: #f4f4f4; color: #1a73e8; }

  .rmc-brand-pill {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    border: 1px solid #e8e8e8;
    font-size: 0.73rem;
    font-weight: 500;
    color: #555;
    background: #f9f9f9;
    cursor: pointer;
    text-decoration: none;
  }
  .rmc-show-more {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    color: #1a73e8;
    padding: 6px 0 0;
    display: flex;
    align-items: center;
    font-family: 'DM Sans', sans-serif;
  }

  .rmc-main { flex: 1; min-width: 0; }
  .rmc-result-bar { margin-bottom: 10px; font-size: 0.83rem; color: #999; }

  .rmc-product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  .rmc-skeleton-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  @keyframes shimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  .rmc-skeleton-img {
    width: 100%;
    height: 155px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.4s infinite;
  }
  .rmc-skeleton-line {
    height: 10px;
    border-radius: 5px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.4s infinite;
  }

  .rmc-card-link { text-decoration: none; color: inherit; }
  .rmc-card {
    position: relative;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #dfdfdf;
    overflow: hidden;
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .rmc-card:hover {
    box-shadow: 0 6px 22px rgba(0,0,0,0.10);
    transform: translateY(-2px);
  }
  .rmc-img-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f8f8;
    overflow: hidden;
    position: relative;
    background: #fff0;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 50%;
    position: relative;
    height: 215px;
  }
  .rmc-img-wrap img,
  .rmc-img-wrap span img {
    max-width: 100%;
    object-fit: contain;
    height: 215px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    position: relative;
    z-index: 2;
    padding: 8px;
  }

  .rmc-filter-toggle {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 7px 14px;
    border-radius: 20px;
    border: 1.5px solid #ddd;
    background: #fff;
    font-weight: 600;
    font-size: 0.82rem;
    cursor: pointer;
    color: #333;
    font-family: 'DM Sans', sans-serif;
  }

  .rmc-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 1000;
  }
  .rmc-overlay.open { display: block; }
  .rmc-drawer {
    position: fixed;
    top: 0; left: 0;
    width: 280px;
    height: 100vh;
    background: #fff;
    z-index: 1001;
    overflow-y: auto;
    box-shadow: 4px 0 20px rgba(0,0,0,0.13);
    transform: translateX(-100%);
    transition: transform 0.28s cubic-bezier(.4,0,.2,1);
    padding: 0 16px 40px;
  }
  .rmc-drawer.open { transform: translateX(0); }
  .rmc-drawer-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0 10px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 12px;
  }

  @media (max-width: 768px) {

    .rmc-mobile-bar  { display: flex; }
    .rmc-sidebar     { display: none; }

    .rmc-layout { gap: 0; margin-top: 0; }
    .rmc-main   { width: 100%; }

    .rmc-product-grid,
    .rmc-skeleton-grid {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 10px;
    }

    .rmc-img-wrap { height: 145px; }
  .rmc-img-wrap img,
  .rmc-img-wrap span img {
    height: 145px;
  }

    .rmc-result-bar { display: none; }
  }

  @media (max-width: 380px) {
    .rmc-product-grid,
    .rmc-skeleton-grid {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 8px;
    }
    .rmc-img-wrap { height: 120px; padding: 6px; }
    .rmc-img-wrap img,
    .rmc-img-wrap span img {
    height: 120px;
  }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .rmc-product-grid,
    .rmc-skeleton-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

function formatPrice(value, currency, decimals) {
  if (!value) return "";
  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: currency || "AED",
    maximumFractionDigits: decimals,
  }).format(value);
}

function productTitle(title) {
  return title
    ?.replace(/[^A-Za-z0-9]/g, " ")
    ?.replace(/[^\w\s]/gi, " ")
    ?.replace(/ /g, "-");
}

function ratingFucn(rating) {
  if (!rating || rating === 0 || rating === "0") return false;
  return true;
}

function removeDuplicates(inputString) {
  if (!inputString) return false;
  if (!inputString.toLowerCase().includes("limited time deal")) return false;
  return "Limited Time Deal";
}

function checkIfAnyNumber(badge) {
  return /\d|×/.test(badge);
}

function functionIdLink(id, pid, store_id) {
  return storeIds?.includes(Number(store_id)) ? pid : id;
}

function ProductCountries(code) {
  const map = { US: "USA", AE: "UAE", GB: "UK", IN: "India" };
  return map[code] || code;
}

const handleImgError = (e) => {
  e.target.src = "https://cdn.ebtida.com/1705315901965-Image-not-found.jpg";
};

function GetFilterCountries({ searchCountry, isFetching, countryCode }) {
  const location = useLocation();
  const searchbrand = new URLSearchParams(location.search).get("brand") || null;
  const thisBrand = searchbrand ? `&brand=${searchbrand}` : "";

  const countries = [
    { code: "US", label: "USA", flag: "us" },
    { code: "AE", label: "UAE", flag: "ae" },
    { code: "GB", label: "UK", flag: "gb" },
    ...(countryCode === "US" ? [{ code: "IN", label: "India", flag: "in" }] : []),
  ];

  return (
    <div className="rmc-pill-group">
      {countries.map((c) => {
        const active = searchCountry === c.code || (!searchCountry && c.code === "US");
        return (
          <Link
            key={c.code}
            to={`${window.location.pathname}?country=${c.code}${thisBrand}`}
            className={`rmc-pill${active ? " active" : ""}`}
          >
            <img
              loading="lazy"
              src={`https://flagcdn.com/w20/${c.flag}.png`}
              srcSet={`https://flagcdn.com/w40/${c.flag}.png 2x`}
              alt={c.label}
            />
            {c.label}
          </Link>
        );
      })}
    </div>
  );
}

function SidebarContent({ searchCountry, getProducts, isFetching, countryCode, onClose }) {
  const { t } = useTranslation();
  const location = useLocation();
  const searchThisCountry = new URLSearchParams(location.search).get("country") || null;
  const thisCountry = searchThisCountry ? `&country=${searchThisCountry}` : "";
  const [showAllBrands, setShowAllBrands] = useState(false);
  const uniqueBrands = [...new Set(getProducts?.map((p) => p.brand).filter(Boolean))];
  const pathName = window.location.pathname?.split("/");

  const categories = [
    { slug: "toys", label: "Toys" },
    { slug: "fashion", label: "Fashion" },
    { slug: "gaming console", label: "Gaming & Console" },
    { slug: "headphones", label: "Headphones" },
    { slug: "accessories", label: "Accessories" },
    { slug: "musical instrument", label: "Musical Instrument" },
    { slug: "Gift sets", label: "Gift Sets" },
    { slug: "Mens Grooming", label: "Mens Grooming" },
    { slug: "laptops", label: "Laptops" },
    { slug: "phones", label: "Phones" },
  ];

  return (
    <div style={{ opacity: isFetching ? 0.6 : 1, transition: "opacity 0.2s" }}>
      {onClose && (
        <div className="rmc-drawer-head">
          <span style={{ fontSize: "1rem", fontWeight: 600, color: "#111" }}>Filters</span>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#666",
              display: "flex",
              padding: 4,
            }}
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
      )}

      <div className="rmc-filter-section">
        <p className="rmc-filter-heading">{t("countries") || "Store Countries"}</p>
        <GetFilterCountries searchCountry={searchCountry} isFetching={isFetching} countryCode={countryCode} />
      </div>

      <div className="rmc-filter-section">
        <p className="rmc-filter-heading">{t("other_categories") || "Categories"}</p>
        <nav className="rmc-cat-nav">
          {categories.map((cat) => (
            <Link key={cat.slug} to={`/search/${cat.slug}`} className="rmc-cat-link">
              {cat.label}
            </Link>
          ))}
        </nav>
      </div>

      {uniqueBrands.length > 1 && (
        <div className="rmc-filter-section">
          <p className="rmc-filter-heading">Brands</p>
          <div className="rmc-pill-group">
            {uniqueBrands.slice(0, showAllBrands ? 999 : 8).map((brand) => (
              <Link
                key={brand}
                to={
                  pathName?.includes("search")
                    ? `/search/${brand}`
                    : `${window.location.pathname}?brand=${brand}${thisCountry}`
                }
                className="rmc-brand-pill"
              >
                {brand}
              </Link>
            ))}
          </div>
          {uniqueBrands.length > 8 && (
            <button className="rmc-show-more" onClick={() => setShowAllBrands((v) => !v)}>
              {showAllBrands ? (
                <>
                  {" "}
                  Show less <KeyboardArrowUpIcon style={{ fontSize: 15, verticalAlign: -3 }} />
                </>
              ) : (
                <>
                  {" "}
                  Show more <KeyboardArrowDownIcon style={{ fontSize: 15, verticalAlign: -3 }} />
                </>
              )}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

function SearchPage({
  getProducts,
  isFetching,
  productUpdates,
  searchCountry,
  countryCode,
  searchQuery,
  loadFetch,
  products,
}) {
  const { languageCode } = useSelector((state) => state.auth);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [drawerOpen, setDrawerOpen] = useState(false);

  const sidebarProps = { searchCountry, getProducts, isFetching, countryCode };

  return (
    <div className="rmc-wrap" style={{ width: "100%" }}>
      <style>{STYLES}</style>

      <div className="rmc-mobile-bar">
        <button className="rmc-filter-toggle" onClick={() => setDrawerOpen(true)}>
          <TuneIcon style={{ fontSize: "1rem" }} />
          Filters
        </button>
      </div>

      <div className="rmc-layout">
        <aside className="rmc-sidebar">
          <SidebarContent {...sidebarProps} />
        </aside>

        <div className="rmc-main">
          <div className="rmc-product-grid">
            {getProducts?.map((item, i) => {
              const selectedShipping = productUpdates?.find((s) => s.id === item.id);
              const prices = item?.prices || selectedShipping?.prices;
              const inStock = item?.in_stock ?? selectedShipping?.in_stock;
              const brand = item?.brand || selectedShipping?.brand;
              const dealbBadge = item?.deal_badge || selectedShipping?.deal_badge;

              return (
                <Link
                  key={i}
                  className="rmc-card-link"
                  to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(
                    item?.id,
                    item?.pid,
                    item?.store_id
                  )}/${productTitle(item?.title)}?country=${item?.country}`}
                >
                  <div className="rmc-card">
                    {!checkIfAnyNumber(dealbBadge) && removeDuplicates(dealbBadge) && (
                      <div
                        style={{
                          position: "absolute",
                          top: 7,
                          left: 7,
                          background: "#ff4757",
                          color: "#fff",
                          fontSize: "0.6rem",
                          fontWeight: 700,
                          padding: "2px 7px",
                          borderRadius: 4,
                          zIndex: 2,
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        {removeDuplicates(dealbBadge)}
                      </div>
                    )}

                    {prices?.deal_value && (
                      <span
                        style={{
                          position: "absolute",
                          top: 7,
                          right: 7,
                          background: "#ff4757",
                          color: "#fff",
                          borderRadius: "50%",
                          width: 22,
                          height: 22,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 2,
                        }}
                      >
                        <FlashOnIcon style={{ fontSize: "0.8rem" }} />
                      </span>
                    )}

                    <div className="rmc-img-wrap">
                      <LazyLoadImage
                        alt={item?.title}
                        effect="blur"
                        src={item?.image}
                        onError={handleImgError}
                        wrapperStyle={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </div>

                    <div
                      style={{ padding: "9px 11px 11px", flex: 1, display: "flex", flexDirection: "column", gap: 3 }}
                    >
                      <h3
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#222",
                          lineHeight: 1.35,
                          margin: 0,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          minHeight: 34,
                        }}
                      >
                        {item?.title?.replace(/[^\w\s.,'/:]/gi, " ")}
                      </h3>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 4,
                          marginTop: 2,
                        }}
                      >
                        {brand && (
                          <span
                            style={{
                              fontSize: "0.68rem",
                              color: "#aaa",
                              fontWeight: 500,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "60%",
                            }}
                          >
                            {brand}
                          </span>
                        )}
                        {ratingFucn(item?.rating) && (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 2,
                              fontSize: "0.68rem",
                              fontWeight: 600,
                              color: "#666",
                              background: "#fff8f2",
                              border: "1px solid #ffe4cc",
                              borderRadius: 20,
                              padding: "2px 6px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.rating}
                            <GradeIcon style={{ fontSize: "0.7rem", color: "#fe7f4a" }} />
                          </span>
                        )}
                      </div>

                      <div style={{ display: "flex", alignItems: "baseline", gap: 5, flexWrap: "wrap", marginTop: 3 }}>
                        {!prices ? (
                          <span style={{ fontSize: "0.68rem", color: "#bbb", fontStyle: "italic" }}>Fetching…</span>
                        ) : Number(prices?.bdp) === 0 ? (
                          <span
                            style={{
                              fontSize: "0.7rem",
                              background: "#f0f0f0",
                              color: "#666",
                              padding: "2px 7px",
                              borderRadius: 4,
                            }}
                          >
                            Check Price
                          </span>
                        ) : inStock ? (
                          <>
                            <span style={{ fontSize: "0.92rem", fontWeight: 700, color: "#111", lineHeight: 1.2 }}>
                              {formatPrice(prices?.value, prices?.currency, 0)}
                            </span>
                            {prices?.deal_value && (
                              <span style={{ fontSize: "0.7rem", color: "#bbb", textDecoration: "line-through" }}>
                                {formatPrice(prices?.price, prices?.currency, 0)}
                              </span>
                            )}
                          </>
                        ) : null}
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: "auto", paddingTop: 5 }}>
                        <span style={{ fontSize: "12px", color: "#bbb" }}>From</span>
                        <img
                          loading="lazy"
                          src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                          alt=""
                          style={{ width: 17, objectFit: "contain" }}
                        />
                        <span style={{ fontSize: "12px", color: "#bbb" }}>{ProductCountries(item?.country)}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>

          {loadFetch && (
            <div className="row" style={{ width: "100%" }}>
              <LoadMoreSkeleton />{" "}
            </div>
          )}

          {loadFetch ? (
            ""
          ) : (
            <>
              {products?.length === 0 && (
                <div className="no-result-found-secton">
                  <ErrorOutlineOutlinedIcon style={{ color: "#721c24" }} />
                  <div style={{ border: "none", background: "#fff0" }} className="cardTitle alert alert-danger">
                    Looks like we couldn't find what you're searching for.
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className={`rmc-overlay${drawerOpen ? " open" : ""}`} onClick={() => setDrawerOpen(false)} />

      <div className={`rmc-drawer${drawerOpen ? " open" : ""}`}>
        <SidebarContent {...sidebarProps} onClose={() => setDrawerOpen(false)} />
      </div>
    </div>
  );
}

export default SearchPage;
